import * as React from 'react'
import BaseBasicAlertCondition from '../BaseBasicAlertCondition/BaseBasicAlertCondition'
import Select from '@mulesoft/anypoint-components/lib/Select'
import { areConditionFieldsEqual, BasicAlertConditionFields, BasicAlertConditionProps, basicAlertsOperators, } from '../../../../../../model'
import { SelectorOption } from '../../../../../../../../common/redux/selector/model'

export type ExternalProps = BasicAlertConditionProps & {
  metric: string
  unit?: string
}

export type ValueProps = {
  policies: SelectorOption[]
  arePoliciesLoading: boolean
}

export type EventProps = {
  fetchPolicies: (orgId: string, apiId: string) => void
}

export type Props = ExternalProps & ValueProps

export type AllProps = Props & EventProps

type State = {
  fields: BasicAlertConditionFields
}

export class APIPolicyViolationCondition extends React.PureComponent<AllProps, State> {

  constructor(props: AllProps) {
    super(props)

    this.onPolicyChange = this.onPolicyChange.bind(this)
    this.isPolicySelectorDisabled = this.isPolicySelectorDisabled.bind(this)

    this.state = {fields: {...props.fields}}
  }

  onPolicyChange (e: { value: string }) {
    const fields = {...this.state.fields, policyId: e.value}

    this.props.onChange(fields)
    this.setState({...this.state, fields})
  }

  isPolicySelectorDisabled() {
    const {fields} = this.state
    const {arePoliciesLoading} = this.props

    return arePoliciesLoading || !fields.orgId || !fields.envId || !fields.apiId
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any) {
    const {fields} = this.state
    const prevFields = prevState.fields

    if (!areConditionFieldsEqual(prevProps.fields, this.props.fields)) {
      this.setState({...this.state, fields: {...this.props.fields}})
    }

    const haveOrgEnvOrAPIChanged = prevFields.orgId !== fields.orgId || prevFields.envId !== fields.envId || prevFields.apiId !== fields.apiId

    if (fields.orgId && fields.envId && fields.apiId && haveOrgEnvOrAPIChanged) {
      this.props.fetchPolicies(fields.orgId, fields.apiId)
    }
  }

  componentDidMount() {
    const {fields} = this.state

    if (fields.orgId && fields.envId && fields.apiId) {
      this.props.fetchPolicies(fields.orgId, fields.apiId)
    }
  }

  render () {
    const {onChange, getValidMinThreshold, metric, unit, policies, arePoliciesLoading} = this.props
    const {fields} = this.state
    const isDisabled = this.isPolicySelectorDisabled() || !!fields.editDisabled

    return (
      <div className="api-policy-violation-condition">
        <div className={'basic-alert-modal-body-input'}>
          <span>Policy</span>
          <Select
            testId={'basic-alert-modal-body-metric-policy-select'}
            options={policies}
            value={fields.policyId}
            onChange={this.onPolicyChange}
            isLoading={arePoliciesLoading}
            disabled={isDisabled}
          />
        </div>
        <BaseBasicAlertCondition
            onChange={onChange}
            getValidMinThreshold={getValidMinThreshold}
            fields={fields}
            metric={metric}
            unit={unit}
        />
      </div>
    )
  }
}
